import React from 'react'

import { StoredReviewItem } from '../../../../schemas/playbook'
import { CollapsibleSummary } from './CollapsibleSummary'
import { RuleItem } from './RuleItem'

interface StatusSectionProps {
  items: StoredReviewItem[]
  totalItems: number
  startIndex: number
  color: string
  title: string
  search: string
  isCollapsed?: boolean
  onToggle: () => void
}

export const StatusSection: React.FC<StatusSectionProps> = ({
  items,
  totalItems,
  startIndex,
  color,
  title,
  search,
  isCollapsed = true,
  onToggle,
}) => {
  const renderItems = items
    .map(
      (item, index) =>
        !item.resolved &&
        item.ruleName.toLowerCase().includes(search.toLowerCase()) && (
          <RuleItem
            key={item.ruleName}
            item={item}
            index={startIndex + index}
            isLastInSection={index === items.length - 1}
          />
        )
    )
    .filter(Boolean)

  return (
    <CollapsibleSummary
      title={title}
      color={color}
      issueCount={totalItems}
      isCollapsed={isCollapsed}
      onToggle={onToggle}
    >
      {renderItems.length > 0 && (
        <div className="flex flex-col">{renderItems}</div>
      )}
    </CollapsibleSummary>
  )
}
